<template lang="html">
  <div class="page-section">
    <div class="list-accordion">
      <div class="container">
        <AccordionItem
          v-for="(item, index) in items"
          :key="`accordion-item-${index}`"
          @highlightField="highlightField"
          :item="parse(item)"/>
      </div>
    </div>
  </div>
</template>

<script>
import AccordionItem from '@/components/Previewers/Accordion/AccordionItem'
import parseComponent from '@/mixins/parseComponent'

export default {
  name: 'Accordion',

  mixins: [parseComponent],

  props: {
    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  components: {AccordionItem}
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'

.list-accordion
  .height-enter-active,
  .height-leave-active
    transition: all .5s
    max-height: 500px

  .height-enter,
  .height-leave-to
    opacity: 0
    max-height: 0
</style>
